export class SurveysResponse{
    id_survey_response: number;
    fk_survey: number;
    participant_key: string;
    name_key: string;
    responses: string;
    nps_value: number;
    nps_feedback: string;
    name: string;
    sendedat: string;
    respondedat: string;
    createdat: string;
    updatedat: string;
    deletedat: string;
    fk_user_create: number;
    fk_user_update: number;
    fk_user_delete: number;
    tags: any;
    referral_share_code: string;
    abandonment: boolean
    fk_audience: number | null;
    anonymous: boolean;
    device_info: string;
    comments: string;   
    key_attendance: string;
    fk_contact: number;
    fk_status_referral: number;
    point_indicated: number;
    properties: string;
    url_redirected: string;
}
